module.exports = __webpack_public_path__ + "static/media/hadensimatrix.dae44567.png";